import { useRef } from "react";


export default function usePeerConnection(audioElementRef) {
    const peerConnection = useRef(null);

    const createPeerConnection = async () => {
        const pc = new RTCPeerConnection();
        audioElementRef.current = document.createElement("audio");
        audioElementRef.current.autoplay = true;

        pc.ontrack = (e) => {
            audioElementRef.current.srcObject = e.streams[0];
        };

        const mediaStream = await navigator.mediaDevices.getUserMedia({
            audio: true,
        });
        pc.addTrack(mediaStream.getTracks()[0]);

        peerConnection.current = pc;
        return pc;
    };

    const closePeerConnection = () => {
        if (peerConnection.current) {
            peerConnection.current.getSenders().forEach((sender) => {
                if (sender.track) sender.track.stop();
            });
            peerConnection.current.close();
            peerConnection.current = null;
        }
    };

    return {
        peerConnection,
        createPeerConnection,
        closePeerConnection,
    };
}
